import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import { LinearProgress } from '@mui/material';
import { Outlet } from 'react-router-dom';

const Error = props => {

  return (
    <main className={'h-full'}>
      <Suspense fallback={<LinearProgress />}>
        <Outlet />
      </Suspense>
    </main>
  );
};

Error.propTypes = {
  route: PropTypes.object
};

export default Error;
